/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Divider from '@mui/material/Divider'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import { editMediaItemsJSX } from './elements/editMediaItemsJSX'
import { editAboutMeJSX } from './elements/editAboutMeJSX'
import { editPromptsJSX } from './elements/editPromptsJSX'
import { editHobbiesJSX } from './elements/editHobbiesJSX'
import { vitalInfoJSX } from '../../user/bio/helpers/vitalInfoJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight } from '../../../helpers/variableDefaults'
import { standardInfoTooltip } from '../../../helpers/tooltips'
import { standardSpinner } from '../../../helpers/spinners'
import { TabPanel } from '../../../helpers/formatting'

export const editProfileTabJSX = (
  isDemo,
  value, index, 
  user, setUser,
  datingProfile, setDatingProfile,
  previousDatingProfile, setPreviousDatingProfile,
  selectedMediaItemIndex, setSelectedMediaItemIndex, 
  newMediaItem, setNewMediaItem,
  openMediaItemSelectModal, setOpenMediaItemSelectModal,
  customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
  selectedPromptIndex, setSelectedPromptIndex, 
  newPrompt, setNewPrompt,
  openPromptSelectModal, setOpenPromptSelectModal,
  customPromptSelected, setCustomPromptSelected,
  selectedHobbyIndex, setSelectedHobbyIndex, 
  newHobby, setNewHobby,
  openHobbySelectModal, setOpenHobbySelectModal,
  customHobbySelected, setCustomHobbySelected,
  newAboutMe, setNewAboutMe,
  openAboutMeSelectModal, setOpenAboutMeSelectModal,
  customAboutMeSelected, setCustomAboutMeSelected,
  bioObject, setBioObject,
  newVitalInfo, setNewVitalInfo,
  loadingVitalInfo, setLoadingVitalInfo,
  loading, setLoading,
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  return (
    <TabPanel value={value} index={index}>
      {loading.loading ?
        standardSpinner()
        : 
        <Box sx={{ 
          // backgroundColor: 'yellow',
          mt: 0, mb: 0, 
          width: width < positionChangeWidthSm ? '100%' : '90vw', maxWidth: positionChangeWidthSm, 
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
        }}>

          {/* Media Items */}
          {editMediaItemsJSX(
            isDemo,
            user, setUser,
            datingProfile, setDatingProfile,
            previousDatingProfile, setPreviousDatingProfile,
            selectedMediaItemIndex, setSelectedMediaItemIndex, 
            newMediaItem, setNewMediaItem,
            openMediaItemSelectModal, setOpenMediaItemSelectModal,
            customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
            openPromptSelectModal, openAboutMeSelectModal, openHobbySelectModal,
            loading, setLoading,
            saveSuccessful, setSaveSuccessful,
            errors, setErrors,
            resetLoadingAndErrors, resetSaveSuccessful,
            width
          )}

          {/* About Me */}
          {
            (
              datingProfile.type === 'bumble' 
              || datingProfile.type === 'tinder'
            ) 
            && 
            editAboutMeJSX(
              isDemo,
              user, setUser,
              datingProfile, setDatingProfile,
              previousDatingProfile, setPreviousDatingProfile,
              newAboutMe, setNewAboutMe,
              openAboutMeSelectModal, setOpenAboutMeSelectModal,
              customAboutMeSelected, setCustomAboutMeSelected,
              openMediaItemSelectModal, openPromptSelectModal, openHobbySelectModal,
              loading, setLoading,
              saveSuccessful, setSaveSuccessful,
              errors, setErrors,
              resetLoadingAndErrors, resetSaveSuccessful,
              width
            )
          }

          {/* Prompts */}
          {editPromptsJSX(
            isDemo,
            user, setUser,
            datingProfile, setDatingProfile,
            previousDatingProfile, setPreviousDatingProfile,
            selectedPromptIndex, setSelectedPromptIndex,
            newPrompt, setNewPrompt,
            openPromptSelectModal, setOpenPromptSelectModal,
            customPromptSelected, setCustomPromptSelected,
            openMediaItemSelectModal, openAboutMeSelectModal, openHobbySelectModal,
            loading, setLoading,
            saveSuccessful, setSaveSuccessful,
            errors, setErrors,
            resetLoadingAndErrors, resetSaveSuccessful,
            width
          )}

          {/* Hobbies */}
          {
            (
              datingProfile.type === 'bumble' 
              || datingProfile.type === 'tinder'
            ) 
            && 
            editHobbiesJSX(
              isDemo,
              user, setUser,
              datingProfile, setDatingProfile,
              previousDatingProfile, setPreviousDatingProfile,
              selectedHobbyIndex, setSelectedHobbyIndex,
              newHobby, setNewHobby,
              openHobbySelectModal, setOpenHobbySelectModal,
              customHobbySelected, setCustomHobbySelected,
              openMediaItemSelectModal, openPromptSelectModal, openAboutMeSelectModal,
              loading, setLoading,
              saveSuccessful, setSaveSuccessful,
              errors, setErrors,
              resetLoadingAndErrors, resetSaveSuccessful,
              width
            )
          }

          {/* Vital Info */}
          {vitalInfoJSX(
            'editProfile',
            bioObject, setBioObject,
            newVitalInfo, setNewVitalInfo,
            loadingVitalInfo, setLoadingVitalInfo,
            saveSuccessful, setSaveSuccessful,
            errors, setErrors,
            width,
            isDemo
          )}
        </Box>
      }
    </TabPanel>
  )
}